import React from "react"

import InputItemWrapper from "./InputItemWrapper"
import SimpleInput from "./SimpleInput"

const LabeledSimpleInput = ({
  id = null,
  label = null,
  type = "text",
  placeholder = null,
  disabled = false,
  error = false,
  errorPosition,
  ...props
}) => (
  <InputItemWrapper id={label} label={label} error={error} errorPosition={errorPosition}>
    <SimpleInput
      id={id || label}
      name={id}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      error={!!error}
      {...props}
    />
  </InputItemWrapper>
)

export default LabeledSimpleInput
